import { remark } from "remark";
import remarkGfm from "remark-gfm";

import { remarkJsonExtractPlugin, type ExtractedJsonData } from "./remarkJsonExtractPlugin";

/**
 * Preprocesses message content to extract JSON commands before rendering.
 * Uses remark to parse markdown and extract JSON code blocks in a single pass.
 */
export async function preprocessMessageContent(content: string): Promise<ExtractedJsonData> {
    const processor = remark().use(remarkGfm).use(remarkJsonExtractPlugin);

    const result = await processor.process(content);

    return result.data.extractedJson as ExtractedJsonData;
}
